export default {
  notSupported: 'Zarządzanie recepturami nie jest dostępne dla tego typu pieca.',
};
